import {size, moment, range, createSelector, Moment} from 'vendor';
import {date, today} from 'store/common';
import type {AnyObject} from 'types';

export const startOfMonth = createSelector(
  [date, today],
  (date, today) => (date ?? today).clone().startOf('month').unix(),
  {memoizeOptions: {maxSize: 50}}
);

export const daysInMonth = createSelector(
  [date, today],
  (date, today) => {
    const start = (date ?? today).clone().startOf('month');
    const end = start.clone().endOf('month');
    return end.diff(start, 'days') + 1;
  },
  {memoizeOptions: {maxSize: 50}}
);

export const month = createSelector(
  [startOfMonth, daysInMonth],
  (startOfMonth, daysInMonth) => range(daysInMonth).map(i => moment.unix(startOfMonth + i * 24 * 60 * 60)),
  {memoizeOptions: {maxSize: 50}}
);

export const monthDetailed = createSelector(
  [month],
  (days) => new Month(days),
  {memoizeOptions: {maxSize: 50}}
);

const last = 6;

class Month {
  lastSevenDays: AnyObject<number> = {};
  occurences: AnyObject<number> = {};
  weekdays: AnyObject<number> = {};
  weekendDays: AnyObject<number> = {};
  lastDay = 0;
  lastWeekendDay = 0;
  lastWeekday = 0;

  constructor(days: Moment[]) {
    const counters: AnyObject<number> = {};
    for (const day of days) {
      const dayname = day.format('ddd');
      const ts = day.unix();
      counters[dayname] = counters[dayname] || 0;
      this.occurences[ts] = ++counters[dayname];
      this.lastSevenDays[dayname] = ts;
      this.lastDay = ts;
      if (/Sat|Sun/.test(dayname)) {
        this.lastWeekendDay = ts;
        this.weekendDays[ts] = size(this.weekendDays) + 1;
      } else {
        this.lastWeekday = ts;
        this.weekdays[ts] = size(this.weekdays) + 1;
      }
    }
  }

  getOccurrence(date: Moment) {
    if (this.lastSevenDays[date.format('ddd')] === date.unix()) {
      return last;
    }
    return this.occurences[date.unix()];
  }

  // @todo improve
  matchesRepeatDays(date: Moment, {repeatDays, repeatCount}: {repeatDays: string, repeatCount: number}) {
    const {lastDay, lastWeekday, lastWeekendDay, weekdays, weekendDays} = this;
    switch (repeatDays) {
      case 'day':
        return repeatCount === last ? date.unix() === lastDay : date.date() === repeatCount;
      case 'weekday':
        return repeatCount === last ? date.unix() === lastWeekday : weekdays[date.unix()] === repeatCount;
      case 'weekend_day':
        return repeatCount === last ? date.unix() === lastWeekendDay : weekendDays[date.unix()] === repeatCount;
    }
  }
}
